import React, { useRef, useEffect } from 'react'

interface AutoResizeTextareaProps {
    value: string
    onChange: (value: string) => void
    onFocus?: () => void
    placeholder?: string
    disabled?: boolean
    minHeight?: string
    className?: string
}

const AutoResizeTextarea: React.FC<AutoResizeTextareaProps> = ({
    value,
    onChange,
    onFocus,
    placeholder = '',
    disabled = false,
    minHeight = '50px',
    className = 'form-control mb-3',
}) => {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null)

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto'
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
        }
    }, [value])

    return (
        <textarea
            ref={textareaRef}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            value={value}
            onFocus={onFocus}
            onChange={(e) => onChange(e.target.value)}
            style={{
                minHeight,
                overflow: 'hidden',
                resize: 'none',
            }}
        />
    )
}

export default AutoResizeTextarea
